const startTimes = []

export function startTimer() {
  startTimes.push(new Date())
}

export function peekTimer() {
  return endTimer(true)
}

export function endTimer() {
  let peek = arguments.length > 0 ? arguments[0] : false
  let endTime = new Date()
  let timeDiff = endTime - (peek ? startTimes[startTimes.length-1] : startTimes.pop()) //in ms
  // rescale to seconds
  timeDiff /= 1000
  return timeDiff
}

export function formatTimer(timeDiff) {
  if (timeDiff > 60) {
    const seconds = timeDiff % 60
    return `${Math.trunc(timeDiff/60)}:${seconds < 10 ? '0' : ''}${Math.round(seconds*100)/100}`
  }
  return `${Math.round(timeDiff*100)/100}s`
}

export function finishTimer (caption, restart = false) {
  console.log(caption + ':', formatTimer(endTimer()))
  if (restart) startTimer()
}

export function continueTimer (caption) {
  console.log(caption + ':', formatTimer(peekTimer()))
}
